const enqueueSnackBar = 'ENQUEUE_SNACKBAR';
const removeSnackBar = 'REMOVE_SNACKBAR';


export {
  enqueueSnackBar,
  removeSnackBar
}